import { shallowEqual } from 'react-redux';
import { Navigate, Outlet } from 'react-router';
import { useLocation } from 'react-router-dom';
import { selectUser } from 'ducks/user/selectors';
import { PRIVATE } from 'router/routes';
import { useAppSelector } from 'store/hooks';

import { Loading } from 'components/loading/Loading';
import { ErrorModal } from 'components/modals/error/ErrorModal';

import { ComingSoon } from './ComingSoon';

import cn from 'templates/Template.module.scss';

export default () => {
  const location = useLocation();
  const { token } = useAppSelector(selectUser, shallowEqual);

  if (process.env.REACT_APP_ENVIRONMENT !== 'development') {
    return <ComingSoon />;
  }

  if (token) {
    return <Navigate to={location.state?.referer || PRIVATE.PAIRS.path} />;
  }

  return (
    <div className={cn.public}>
      <Outlet />
      <Loading />
      <ErrorModal />
    </div>
  );
};
